module.exports = __webpack_public_path__ + "img/logo.ffa84ae3.png";